module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsSAAALEgHS3X78AAAA50lEQVQ4y62UwQ3CMAxF30fcYYRsABvQERihm8EIjFA2KBt0hGxgDiQoBJcGhKWoUmy/NP6OAXogAta4zmZGuUiACOxrpxPsgrJjEVBA+hoEYC2ADEnfF9CaH8zMzpIATpJQossLlrQHtilxkBSBzQz47be3wFCpEoHjTJ1cyFgqlqBjSgiLkKJox2o/zMhrK+d6IZEv1Z0n4Jr9pXmQDrh9o5YHGYHdPyBI6iu5A3DI/haJszpdUdS8F1olDk6fTN4bA6y1Y6OZjTMxnyEtJunRJ+nEXwDPvOahVNWiKybi1+OxfpT9Hc4VgpXlbDEHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Open bill.png
// module id = 183
// module chunks = 0 1